export default __webpack_public_path__ + "static/layout-icons-b063e0de45c4810628dc76c89ee1c3bf.svg";